import JobStatusEnum from '@jobs/models/job-status-enum';
import { parseDate } from '@lib/dateUtils';

export const getJobStatus = (
  isDeleted: boolean,
  startDateString: string,
  endDateString: string | null,
): JobStatusEnum => {
  const now = new Date();
  const startDate = parseDate(startDateString);
  const endDate = endDateString ? parseDate(endDateString) : null;

  if (isDeleted) return JobStatusEnum.INACTIVE;
  if (!endDate)
    return startDate > now
      ? JobStatusEnum.PENDING_PUBLICATION
      : JobStatusEnum.PUBLISHED;
  if (endDate <= now) return JobStatusEnum.EXPIRED;
  if (startDate >= now) return JobStatusEnum.PENDING_PUBLICATION;

  return JobStatusEnum.PUBLISHED;
};
